<template>
  <div>
    <TextInput v-if="withName" :label="lang.name" :placeholder="lang.name" :model="model" name="name" />

    <TextInput v-if="withRemark" :label="lang.remark" :placeholder="lang.remark" :model="model" name="additional_remark" />

    <Select
      :label="label || lang.country"
      @change="onCountryChange"
      :model="model"
      :options="countries"
      name="country_id"
    />

    <TextInput :label="lang.zip_code" @change="onZipCodeChange" :model="model" name="zip_code" />

    <TextInput
      :label="lang.house_number"
      @change="onHouseNumberChange"
      :model="model"
      name="house_number"
    />

    <TextInput
      :label="lang.street"
      :key="`street-sync-${loading}'`"
      @change="lookupAddress && onStreetChange($event)"
      :model="model"
      name="street"
      :loading="loading"
    />

    <TextInput
      :label="lang.city"
      :key="`city-sync-${loading}'`"
      @change="lookupAddress && onCityChange($event)"
      :model="model"
      name="city"
      :loading="loading"
    />
  </div>
</template>


<script>
import TextInput from "./TextInput";
import Select from "./Select";
import LocationService from "@/services/LocationService";

const locationService = new LocationService();

export default {
  name: "form-group-address",
  props: ["model", "withName", "withRemark", "countries", "label", "lookupAddress"],
  data() {
    return {
      tries: 0,
      loading: false,
      lang: i18n.app.components.address
    };
  },
  components: {
    TextInput,
    Select
  },
  methods: {
    onZipCodeChange() {
      this.syncAddress();
    },
    onHouseNumberChange() {
      this.syncAddress();
    },
    onStreetChange() {
      this.syncAddress();
    },
    onCityChange() {
      this.syncAddress();
    },
    onCountryChange() {
      this.$emit("countryChanged");
      this.syncAddress();
    },
    getSelectedCountry() {
      const country = (this.countries || []).filter(
        country => country.value === this.model.country_id
      )[0];

      return country && country.text;
    },
    syncAddress() {
      const zipCode = this.model.zip_code;
      const houseNumber = this.model.house_number;
      const countryId = this.model.country_id;
      const street = this.model.street;
      const city = this.model.city;
      const selectedCountry = (this.countries || []).filter(
        country => country.value === countryId
      )[0];

      const allFieldsSet = (this.model.zip_code && this.model.house_number && selectedCountry && this.model.street && this.model.city);

      const isSupportingAddressSearch =
        selectedCountry?.is_supporting_address_search ||
        selectedCountry?.data?.is_supporting_address_search;
      if (zipCode && houseNumber && countryId && isSupportingAddressSearch && this.tries < 4) {
        this.loading = true;

        locationService
          .findByZipCodeAndHouseNumber(zipCode, houseNumber, countryId)
          .then(data => {
            // An empty answer means the country has no lookup, or the postcode
            // was not found. Either way the typed address stands.
            if (data?.street) {
              this.model.street = data.street;
            }

            if (data?.city) {
              this.model.city = data.city;
            }

            this.$emit('addressupdate', data);
            this.tries++;
          })
          .finally(() => {
            this.loading = false;
          });
      }

      if (allFieldsSet) {
        locationService
          .findByAddress(zipCode, houseNumber, countryId, street, city)
          .then(data => {
            if (data?.street) {
              this.model.street = data.street;
            }
            if (data?.city) {
              this.model.city = data.city;
            }
            this.$emit('addressupdate', data);
            this.tries++;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>
